import { ACTION_TYPE, Action, ActionPersistData, ElementToCreate, ElementToDelete, Operation, OperationType } from "../action.model";

export class OpDelete<ElementTypes, TypeName extends keyof ElementTypes, ElementType extends ElementTypes[TypeName], AppLogInfos, Context> implements Operation<ElementTypes, AppLogInfos, Context> {

    constructor(protected readonly _elementTypeName: TypeName, protected _elementToDelete: ElementType) {
    }

    /** @inheritdoc */
    public getElement(): ElementType {
        return this._elementToDelete;
    }

    /** @inheritdoc */
    public get elementTypeName(): keyof ElementTypes { return this._elementTypeName; }

    /**
     * delete element
     */
    public process(action: Action<ElementTypes, AppLogInfos, Context>): void {
        action.getCacheManager().getDTOCacheRepository(this._elementTypeName).remove(this._elementToDelete);
    }

    /**
     * (re)create element
     */
    public undo(action: Action<ElementTypes, AppLogInfos, Context>): void {
        action.getCacheManager().getDTOCacheRepository(this._elementTypeName).push(this._elementToDelete);
    }

    /**
     * Returns the type of the current Operation
     * @returns {OperationType}
     */
    public getOperationType(): OperationType {
        return OperationType.DELETE;
    }

    /**
     * Action to string
     * @param action 
     * @returns {string}
     */
    public toString(action: Action<ElementTypes, AppLogInfos, Context>): string {
        return `Delete ${String(this._elementTypeName)}: ${this._elementToDelete}`;
    }

    /**
     * update internal objects (retrieve the element from the cache or update ids and foreign keys)
     */
    public actualize(action: Action<ElementTypes, AppLogInfos, Context>): void {
        this._elementToDelete = action.getCacheManager().getDTOCacheRepository(this._elementTypeName).getUpToDateElement(this._elementToDelete) as ElementType;
    }

    /**
     * Add server server action element to ActionPersistenceData
     */
    public addServerActionElement(actionPersistenceData: ActionPersistData<Context>, params: { action: Action<ElementTypes, AppLogInfos, Context>, actionType: ACTION_TYPE }): void {
        const dtoCacheRepository = params.action.getCacheManager().getDTOCacheRepository(this._elementTypeName);
        if (params.actionType === ACTION_TYPE.UNDO) {
            // We need to get up to date id in case the same action is creating a element and deleting it. (E.g. Zurvan-transport 3 panels duplicates an item before removing a part of it) 
            const id = dtoCacheRepository.getUpToDateId(dtoCacheRepository.getId(this._elementToDelete));
            const element = { ...this._elementToDelete };
            dtoCacheRepository.setId(element, id);
            const elementsToCreate: ElementToCreate = {
                elementTypeName: String(this._elementTypeName),
                element,
                isRecreate: true
            };

            if (!actionPersistenceData.elementsToCreate) {
                actionPersistenceData.elementsToCreate = [];
            }
            actionPersistenceData.elementsToCreate.push(elementsToCreate);

        } else {
            const elementsToDelete: ElementToDelete = {
                elementTypeName: String(this._elementTypeName),
                elementId: dtoCacheRepository.getId(this._elementToDelete)
            };
            if (!actionPersistenceData.elementsToDelete) {
                actionPersistenceData.elementsToDelete = [];
            }
            actionPersistenceData.elementsToDelete.push(elementsToDelete);
        }
    }
}